import React from 'react'

import Markdown from '../../markdown'
import * as Types from '../../types'

const article: Types.Article = {
  title: 'The learning queue is broken.',
  url: 'learning-queue',
  date: new Date('Aug 7 2025').getTime(),
  feedContent: (
    <Markdown>{`
Spaced-repetition tools have a blind spot for one of the most common ways they're used: learning premade material. When you're not creating the cards yourself, your first interaction with a card often is when it's introduced for the first time in the learning queue. This is [explicitly discouraged](https://supermemo.guru/wiki/Myth:_Review_your_material_on_the_first_day_several_times), but if so many people use these tools in this way shouldn't we take it into account?
`}</Markdown>
  ),
  tags: [],
  loadContent: () => import('./content'),
}

export default article
